import React, { useState } from 'react';
import type { FC } from 'react';

import { useGetNewsQuery } from '../../entities/news/api/newsApi';
import { NewsCard } from './NewsCard';
import styles from './NewsPage.module.scss';
import { PageHeader } from '../../components/ui/PageHeader/PageHeader';
import { BackButton } from '../../components/ui/BackButton/BackButton';
import { Loading } from '../../components/ui/Loading/Loading';

export const NewsPage: FC = () => {
    const [pageNum, setPageNum] = useState(1);

    const { data, isLoading, isFetching, isError } = useGetNewsQuery({ page_num: pageNum });

    const articles = data?.data ?? [];
    const hasMore = data ? data.page_num < data.pages : false;

    if (isLoading) {
        return (
            <div className={styles.page}>
                <Loading text="Загружаем новости…" size="md" />
            </div>
        );
    }

    if (isError) {
        return <div className={styles.page}>Не удалось загрузить новости</div>;
    }

    return (
        <div className={styles.page}>
            <div className={styles.head}>
                <BackButton />
                <PageHeader
                    title="Новости"
                    meta={data ? [<>Всего <b>{data.count}</b></>] : undefined}
                />
            </div>

            {articles.length === 0 ? (
                <p>Пока новостей нет</p>
            ) : (
                <div className={styles.list}>
                    {articles.map((article) => (
                        <NewsCard key={article.id} article={article} />
                    ))}

                    {hasMore && (
                        <button
                            type="button"
                            className={styles.more}
                            disabled={isFetching}
                            onClick={() => setPageNum((prev) => prev + 1)}
                        >
                            {isFetching ? 'Загрузка...' : 'Показать ещё'}
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};